/* Module Dependencies */
import React from 'react';
import PropTypes from 'prop-types';

/* Constants */
import BUTTON_CONFIG from '../../constants/button.constants';

/* Declare the component */
const Search = ({ ...props }) => {
  const { query, isFavoriteToggle, onSearchInput, toggleFilterModal, hasActiveFilters } = props;

  // Return component
  return (
    <div data-testid="search-component" className={`${isFavoriteToggle ? 'vve-search-filter-disable' : 'vve-search-filter-container'}`}>
      <div className="vve-directory-search-container">
        <input
          data-testid="search-input"
          className={`vve-directory-search-input ${isFavoriteToggle ? 'vve-gray-magnifying-icon' : 'vve-magnifying-icon'}`}
          type="search"
          placeholder="Search"
          value={query}
          onChange={onSearchInput}
          disabled={isFavoriteToggle}
        />
      </div>
      <div className="vve-vertical-line"></div>
      <button data-testid="filter-button" className="vve-filter-container" onClick={() => (isFavoriteToggle ? null : toggleFilterModal())}>
        <span className="vve-filter-title">{BUTTON_CONFIG.FILTER_BUTTON.title}</span>
        <div data-testid="filtericon" className={`vve-filter-icon ${hasActiveFilters ? 'vve-filter-icon-active' : ''}`}>
          {hasActiveFilters && <span className="vve-filter-indicator" data-testid="filter-indicator"></span>}
        </div>
      </button>
    </div>
  );
};

/* PropTypes */
Search.propTypes = {
  query: PropTypes.string.isRequired,
  isFavoriteToggle: PropTypes.bool.isRequired,
  onSearchInput: PropTypes.func.isRequired,
  toggleFilterModal: PropTypes.func.isRequired,
  hasActiveFilters: PropTypes.bool
};

/* Export component */
export default Search;
